import { render } from "./PhotoVideoTutorialScreen.vue?vue&type=template&id=3b65aca9&scoped=true"
import script from "./PhotoVideoTutorialScreen.vue?vue&type=script&lang=js"
export * from "./PhotoVideoTutorialScreen.vue?vue&type=script&lang=js"

import "./PhotoVideoTutorialScreen.vue?vue&type=style&index=0&id=3b65aca9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b65aca9"]])

export default __exports__